import { FlexColumn, StyledButton, StyledSearchBar } from '@gorila-shared-ui/components';
import { useMemo, useState } from 'react';
import { VariableSizeList as List } from 'react-window';
import { useRecoilState, useRecoilValue } from 'recoil';
import { DEFAULT_LIST_ITEM_HEIGHT } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { accountState } from '../../storage/account';
import { isFleetModuleState, selectWorkspaceState, workspaceState, workspacesState } from '../../storage/app';
import { Workspace } from '../../types/workspace';
import StyledModal from '../shared/StyledModal';
import WorkspaceItem from './WorkspaceItem';

export function WorkspacePicker() {
  const { css } = useStyles();
  const workspaces = useRecoilValue(workspacesState);
  const isFleetModule = useRecoilValue(isFleetModuleState);
  const [selectedWorkspace, setSelectedWorkspace] = useRecoilState(workspaceState);
  const [selectWorkspace, setSelectWorkspace] = useRecoilState(selectWorkspaceState);
  const [search, setSearch] = useState('');
  const account = useRecoilValue(accountState);
  const enableSearch = workspaces && workspaces.length > 6;
  const filteredWorkspaces = useMemo(() => {
    if (!workspaces) return [];
    if (!search) return workspaces;
    return workspaces.filter((workspace) => workspace.name.toLowerCase().includes(search.toLowerCase()));
  }, [workspaces, search]);

  if (!workspaces) return null;

  const selectAllWorkspaces = () => {
    if (account?.client) {
      const allWorkspace: Workspace = {
        _id: account?.client._id,
        name: 'Todos',
        tradeName: 'all',
        rfc: '',
        logo: '',
        controlTower: false,
      };
      setSelectedWorkspace(allWorkspace);
      setSelectWorkspace(false);
    }
  };

  return (
    <StyledModal
      isOpen={!selectedWorkspace || selectWorkspace}
      closeable={selectWorkspace}
      onClose={() => setSelectWorkspace(false)}
      size={400}
      title="Selecciona tu espacio de trabajo"
      content={
        <FlexColumn>
          {enableSearch && (
            <StyledSearchBar
              onChange={setSearch}
              value={search}
              clearable
              noMargin
            />
          )}
          <ul
            className={css({
              margin: 0,
              paddingLeft: 0,
              paddingRight: 0,
              minHeight: `${DEFAULT_LIST_ITEM_HEIGHT * 5}px`,
            })}
          >
            <List
              height={DEFAULT_LIST_ITEM_HEIGHT * 5}
              itemCount={filteredWorkspaces.length}
              itemSize={() => DEFAULT_LIST_ITEM_HEIGHT}
              width={'100%'}
              itemData={filteredWorkspaces}
            >
              {WorkspaceItem}
            </List>
          </ul>
          {workspaces?.length !== 1 && !isFleetModule && (
            <StyledButton
              kind="secondary"
              onClick={selectAllWorkspaces}
              full
            >
              Todos
            </StyledButton>
          )}
        </FlexColumn>
      }
    />
  );
}
